export enum SelectedArea {
    Comercial = 1,
    Basica = 2,
    PreBasica = 3
}
